import React from "react";
import {
  Button,
  Image,
  ModalLayout,
  OffCanvasLayout,
  Table,
} from "@wac-ui-dashboard/wac_component_library";
import useDocumentDetail from "./useDocumentDetail";
import EmptyData from "../../../Global/EmptyData";
import { ImageCard } from "../../../Global/ImageCard";
import Style from "./documentDetail.module.scss";
import Assets from "../../../../assets/Assets";
import OverviewShimmer from "../../../Global/Shimmers/OverviewShimmer";
import RequestForm from "./RequestForm";

const DocumentDetail = () => {
  const {
    documentsData,
    isFetching,
    additionalRequests,
    showImageModal,
    imageData,
    docId,
    itemStatus,
    itemStatusLabel,
    itemRejected,
    note,
    rejectReason,
    documentType,
    downloadLoading,
    canStatusChange,
    showRequestModal,
    handleViewImage,
    closeImageModal,
    handleVerification,
    handleDownloadPdf,
    setItemRejected,
    setNote,
    setShowRequestModal,
    handleCloseRequestModal,
    hasRequestPermission,
  } = useDocumentDetail();

  const documents = documentsData?.data;

  const additionalRequestFields = {
    document_type_label: { label: "Document Type", sortable: false },
    comment: { label: "Comment", sortable: false },
    status_label: { label: "Status", sortable: false },
    date: { label: "Date", sortable: false },
    uploaded_date: { label: "Uploaded Date", sortable: false },
  };

  const getAdditionalRow = (field, data) => {
    return <p className="pro-mb-0">{data[field] ?? "---"}</p>;
  };

  return (
    <>
      <div className="pro-mt-5" />

      {isFetching ? (
        <div className="pro-p-4 pro-w-100">
          <OverviewShimmer />
        </div>
      ) : (
        <div className="pro-w-100 pro-pb-6">
          <h6 className="pro-ttl h6 pro-mb-4 pro-fw-bold">Documents</h6>
          {!documents || documents.length === 0 ? (
            <div className={`${Style.empty_wrapper} pro-w-100`}>
              <EmptyData />
            </div>
          ) : (
            <div className={Style.document_section}>
            {documents.map((section, sectionIndex) => (
              <div key={sectionIndex} className={Style.document_card_wrap}>
                <h6 className="pro-ttl h6 pro-mb-3">
                  {section.document_type_label}
                </h6>
                <div className="pro-d-flex pro-flex-wrap pro-gap-3">
                  {section.documents?.map((item, index) => (
                    <div className={`${Style.root}`} key={index}>
                      <div className={`${Style.root_inner}`}>
                        <div
                          className={`${Style.root_image}`}
                          onClick={() => handleViewImage(item, section.document_type_label)}
                        >
                          <Image
                            src={
                              item?.name?.endsWith(".pdf")
                                ? Assets.PDF_IMAGE
                                : item?.url || Assets.MALEPROFILE
                            }
                            width={80}
                            height={70}
                            alt="document"
                          />
                        </div>
                        <div
                          className={`${Style.badge} pro-ps-1 pro-bg-light pro-rounded-3 pro-d-flex pro-items-center`}
                        >
                          <span className={`${Style.badge_text} pro-fw-medium`}>
                            {item?.status_label}
                          </span>
                          <div className="pro-check-box rounded-tick">
                            <img
                              alt="badge"
                              src={
                                item?.status === 0
                                  ? Assets.YELLOWCHECK
                                  : item?.status === 1
                                  ? Assets.GREENCHECK
                                  : item?.status === 2
                                  ? Assets.REDCHECK
                                  : ""
                              }
                            />
                          </div>
                        </div>
                        <div className="pro-pt-3">
                          <p
                            className="pro-fw-medium pro-mb-0 pro-font-sm"
                            title={item?.name}
                            style={{
                              maxWidth: "150px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {item?.name}
                          </p>
                          <p className="pro-mb-0 pro-font-xs">
                            {item?.date}
                          </p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
            </div>
          )}

          {/* Additional Document Requests Table */}
          <div className="pro-pt-4">
            <div className="pro-d-flex pro-justify-between pro-items-center pro-mb-4">
              <h6 className="pro-ttl h6 pro-mb-0">
                Additional Document Requests
              </h6>
              {hasRequestPermission ? (
                <Button
                  className="pro-btn-primary"
                  onClick={() => setShowRequestModal(true)}
                >
                  Request Additional Document
                </Button>
              ) : null}
            </div>
            <Table
              data={additionalRequests?.data || []}
              uniqueID={"id"}
              showCheckBox={false}
              deletable={false}
              assignable={false}
              multiSelect={false}
              fields={additionalRequestFields}
              getRow={getAdditionalRow}
            />
          </div>
        </div>
      )}

      {/* Image/PDF Viewer Modal */}
      <ModalLayout
        show={showImageModal}
        handleClose={closeImageModal}
        backdrop="static"
      >
        <ImageCard
          data={imageData}
          documentType={documentType}
          docId={docId}
          status={!canStatusChange && itemStatus === 0 ? -1 : itemStatus}
          statusLabel={itemStatusLabel}
          verification={handleVerification}
          handleClose={closeImageModal}
          itemRejected={itemRejected}
          setItemRejected={setItemRejected}
          note={note}
          setNote={setNote}
          rejectReason={rejectReason}
          handleDownloadPdf={handleDownloadPdf}
          downloadLoading={downloadLoading}
        />
      </ModalLayout>

      {/* Request Additional Document OffCanvas */}
      <OffCanvasLayout
        show={showRequestModal}
        handleClose={handleCloseRequestModal}
        title="Request Additional Document"
        closeIcon={<span className="material-symbols-outlined">close</span>}
        backdrop="static"
      >
        <RequestForm handleClose={handleCloseRequestModal} />
      </OffCanvasLayout>
    </>
  );
};

export default DocumentDetail;
